export default {
  path: 'detail-statuses',
  name: 'orders.detail-statuses',
  component: () => import('@/views/admin/orders/default/detail-statuses/Index'),
}